import {Action, ActionsCommon} from '../Actions';
import {StateCommon} from '../State';

type PartialStateCommon = Pick<StateCommon, keyof StateCommon>;

function setLoading( loading: boolean ): Action<typeof ActionsCommon>
{
	return {
		type: ActionsCommon.COMMON$_SET_LOADING,
		payload: {loading} as PartialStateCommon,
	};
}

function setVisualMode( visualMode: boolean ): Action<typeof ActionsCommon>
{
	return {
		type: ActionsCommon.COMMON$_SET_VISUAL_MODE,
		payload: {visualMode} as PartialStateCommon,
	};
}

/**
 * Module.
 */
export {
	setLoading,
	setVisualMode,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Store/creators/common.ts